import React, { useState } from "react";
import factorymaker from "../../../main/assets/images/Images/Home-Images/factorymaker1.svg";
import home_2 from "../../../main/assets/images/Images/Home-Images/home_2.png";
import reduceCost from "../../../main/assets/images/Icons/HomePage - Icons/reduce-cost.svg";
import Layer_1 from "../../../main/assets/images/Icons/HomePage - Icons/Layer_1.svg";
import M_Layer_1 from "../../../main/assets/images/Icons/HomePage - Icons/M_Layer_1.svg";
import scalefield from "../../../main/assets/images/Icons/HomePage - Icons/scale-field.svg";
import Layer_2 from "../../../main/assets/images/Icons/HomePage - Icons/Layer_2.svg";
import customerincreased from "../../../main/assets/images/Icons/HomePage - Icons/customer-increased.svg";
import Layer_3 from "../../../main/assets/images/Icons/HomePage - Icons/Layer_3.svg";
import improvetechnicion from "../../../main/assets/images/Icons/HomePage - Icons/improve-technicion.svg";
import Layer_4 from "../../../main/assets/images/Icons/HomePage - Icons/Layer_4.svg";
import purple_1 from "../../../main/assets/images/Icons/HomePage - Icons/purple_1.svg";
import purple_2 from "../../../main/assets/images/Icons/HomePage - Icons/purple_2.svg";
import purple_3 from "../../../main/assets/images/Icons/HomePage - Icons/purple_3.svg";
import purple_4 from "../../../main/assets/images/Icons/HomePage - Icons/purple_4.svg";
import pink_1 from "../../../main/assets/images/Icons/HomePage - Icons/pink_1.svg";
import pink_2 from "../../../main/assets/images/Icons/HomePage - Icons/pink_2.svg";
import pink_3 from "../../../main/assets/images/Icons/HomePage - Icons/pink_3.svg";
import pink_4 from "../../../main/assets/images/Icons/HomePage - Icons/pink_4.svg";
import Operationalplanning from "../Platform/Operationalplanning";
type Props = {};

const Operation = (props: Props) => {
  interface CARDSDATA {
    title?: string;
    subtitle?: string;
    desc?: string;
  }

  const CardsData: CARDSDATA[] = [
    {
      title: "11%",
      subtitle: "upto",
      desc: "Reduction in Operational Expenses",
    },
    {
      title: "40%",
      subtitle: "upto",
      desc: "Reduction in Vendor Dependency",
    },
    {
      title: ">15%",
      subtitle: "upto",
      desc: "Improved Customer Experience",
    },
    {
      title: ">5%",
      subtitle: "upto",
      desc: "Reduction in Carbon Footprint",
    },
  ];

  interface OPERATION {
    id: number;
    image?: string;
    M_image?: string;
    M_whiteIcons?: string;
    whiteIcons?: string;
    title?: string;
    desc?: string;
  }
  const OperationData: OPERATION[] = [
    {
      id: 1,
      image: reduceCost,
      whiteIcons: Layer_1,
      M_image: purple_1,
      M_whiteIcons: pink_1,
      title: "Reduced Costs",
      desc: "Reduce the impact on bottom line.",
    },

    {
      id: 2,
      image: customerincreased,
      whiteIcons: Layer_3,
      M_image: purple_2,
      M_whiteIcons: pink_2,
      title: "Improved Customer Experience",
      desc: "Deliver an exceptional service experience.",
    },
    {
      id: 3,
      image: scalefield,
      whiteIcons: Layer_2,
      M_image: purple_4,
      M_whiteIcons: pink_4,
      title: "Scale Field Services With Business",
      desc: "Scale your operations as you grow.",
    },
    {
      id: 4,
      image: improvetechnicion,
      whiteIcons: Layer_4,
      M_image: purple_3,
      M_whiteIcons: pink_3,
      title: "Increased Productivity",
      desc: "Improved utilization and output.",
    },
  ];

  const [enter, setEnter] = useState(-1);
  const [OperationDatas, setOperationalDatas] = useState(OperationData);

  const MouseEnter = (index) => {
    setEnter(index);
    setOperationalDatas(
      OperationDatas.map((telecom: any, telindex: number) => {
        if (telindex === index) {
          return { ...telecom, selected: 1 };
        } else {
          return { ...telecom, selected: 0 };
        }
      })
    );
  };
  const MouseLeave = (index) => {
    setEnter(index);
    setOperationalDatas(
      OperationDatas.map((telecom: any, telindex: number) => {
        return { ...telecom, selected: 0 };
      })
    );
  };

  const [flippedCards, setFlippedCards] = useState(new Set());
  const handleClick = (id: number) => {
    setFlippedCards((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) newSet.delete(id);
      else newSet.add(id);
      return newSet;
    });
  };

  return (
    <>
      {/* mobile View */}
      <div className="d-block d-md-none">
        <div className="container-fluid position-relative">
          <div className="bg-color-n">
            <p className="pb-50 font-20 fonts-800 pt-40 font-family-roboto text-white-color line-23 text-center w-100 px-40">
              Benefits for Your Supply Chain and Field Operations
            </p>
            <div className="container-fluid row d-flex justify-content-center py-4 px-0">
              <div className="row justify-content-center p-0 w-100 ">
                {OperationData.map((card) => (
                  <div
                    className="col-sm-5 col-md-5 col-lg-5 py-10 px-2"
                    key={card.id}
                    onClick={() => handleClick(card.id)}
                    style={{ width: "180px" }}
                  >
                    <div className="flip-card">
                      <div
                        className={`flip-card-inner ${
                          flippedCards.has(card.id) ? "flipped" : ""
                        }`}
                      >
                        <div className="flip-card-front">
                          <div className="h-100 w-100">
                            <div className="content-wrap front-bg">
                              <div className="d-flex flex-column justify-content-end pb-5 px-2 g-3 h-100">
                                <img
                                  className="flip-card-image"
                                  src={card?.M_image}
                                  alt="background will be here"
                                />
                                <div
                                  className="d-flex flex-column mb-2"
                                  style={{ height: "16px" }}
                                >
                                  <h6
                                    className="text-center text-white justify-content-center font-16 font-family-roboto line-15 fonts-600"
                                    style={{ letterSpacing: "0.25px" }}
                                  >
                                    {card.title}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flip-card-back">
                          <div className="h-100">
                            <div className="content-wrap back-bg">
                              <div className="d-flex flex-column justify-content-center pt-5 h-100">
                                <img
                                  className="flip-card-image"
                                  src={card?.M_whiteIcons}
                                  alt="background will be here"
                                />
                                <div
                                  className="d-flex flex-column m-3"
                                  style={{ height: "6px" }}
                                >
                                  <p className="text-center text-white font-family-roboto font-13 line-17 fonts-600 justify-content-center">
                                    {card.title}
                                  </p>
                                  <div
                                    className={`desc-wrapper ${
                                      flippedCards.has(card.id)
                                        ? "slide-up"
                                        : ""
                                    }`}
                                  >
                                    <p className="text-center text-white mt-1 mb-2 font-family-roboto fonts-400 font-11 line-12 justify-content-center">
                                      {card.desc}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="bg-color-n hx-340"></div>
          <div className="container mt-n-290">
            <div className="row p-0">
              <div className="col-md-12 col-sm-12 col-12">
                <div
                  style={{
                    backgroundImage: "url(" + home_2 + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    height: "550px",
                  }}
                  className="col-md-12 col-lg-12 col-12 justify-content-end h-400 justify-content-center radius-26 overflow-hidden"
                >
                  <div
                    className="pt-0"
                    style={{ height: "550px", width: "102%" }}
                  >
                    <div
                      style={{
                        background: `linear-gradient(to left, rgba(255, 255, 255, 0.01), rgba(0, 0, 0, 01))`,
                      }}
                      className="row col-md-12 col-lg-12 col-12 h-100 d-flex justify-content-between flex-row align-items-end w-100 px-20 hx-300"
                    >
                      {CardsData.map((val, index) => (
                        <div
                          className="col-md-3 col-sm-3 col-12 px-10 h-25"
                          key={index}
                        >
                          <p className="text-white-color font-family-roboto fonts-800 font-20 line-23 ">
                            {val?.subtitle}
                          </p>
                          <h1 className="text-percentage font-family-roboto fonts-600 font-30 line-35 pe-2 ">
                            {val?.title}
                          </h1>
                          <h6 className="text-white-color font-family-roboto fonts-400 font-14 line-16 mb-20 pr-20 w-65">
                            {" "}
                            {val?.desc}
                          </h6>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Website */}
      <div className="d-none d-md-block">
        <div className="container-fluid position-relative">
          <div className="bg-color-n">
            <p className="pb-50 font-30 fonts-800 pt-40 font-family-roboto text-white-color line-35 text-center w-100 px-40">
              Benefits for Your Supply Chain and Field Operations
            </p>
            <div className="container">
              <div className="row">
                {OperationDatas.map((item: any, index: any) => (
                  <div className="col-md-6 col-sm-12 col-lg-3 p-10" key={index}>
                    <div
                      className={`card-container d-flex flex-column py-20 radius-10 justify-content-center`}
                    >
                      <div className="image-container">
                        <img
                          className="front-image mx-5 my-3"
                          src={item?.image}
                          alt="background will be here"
                        />
                        <img
                          className="back-image mx-5 my-3"
                          src={item?.whiteIcons}
                          alt="background will be here"
                        />
                      </div>
                      <div className="card-body">
                        <p
                          className={`d-flex justify-content-center text-center card-title px-2 text-white-color fonts-600 font-family-roboto font-24 line-30 pb-2`}
                        >
                          {item?.title}
                        </p>
                        <p className="px-2 card-desc text-center text-white-color fonts-400 font-20 line-22 font-family-roboto">
                          {item?.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="bg-color-n hx-340"></div>
          <div className="container mt-n-290">
            <div className="row p-0">
              <div className="col-md-12 col-sm-12 col-12">
                <div
                  style={{
                    backgroundImage: "url(" + factorymaker + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                  className="col-md-12 col-sm-12 col-12 justify-content-end h-400 align-items-center justify-content-center radius-26 overflow-hidden"
                >
                  <div className="pt-370">
                    <div
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.01), rgba(0, 0, 0, 01))`,
                      }}
                      className="row col-md-12 col-sm-12 col-12 h-100 d-flex justify-content-between flex-row align-items-start w-100 px-60 hx-200"
                    >
                      {CardsData.map((val, index) => (
                        <div className="col-md-3 col-sm-6 col-12" key={index}>
                          <p className="text-white-color font-family-roboto fonts-800 font-20 line-23">
                            {val?.subtitle}
                          </p>
                          <h1 className="text-percentage font-family-roboto fonts-600 font-50 line-58 pe-2">
                            {val?.title}
                          </h1>
                          <h6 className="text-white-color font-family-roboto fonts-400 font-20 line-23 mb-20 ">
                            {" "}
                            {val?.desc}
                          </h6>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Operation;
